export const initialState = {

};

export const REQUESTER_FILTER_DROPDOWN = 'REQUESTER_FILTER_DROPDOWN';
export const RESPONDING_AS_FILTER_DROPDOWN = 'RESPONDING_AS_FILTER_DROPDOWN';
export const QUESTIONNAIRE_FILTER_DROPDOWN = 'QUESTIONNAIRE_FILTER_DROPDOWN';
export const RECEIVED_OR_PUBLISHED_DATE_FILTER_DROPDOWN = 'RECEIVED_OR_PUBLISHED_DATE_FILTER_DROPDOWN';
export const DUE_DATE_FILTER_DROPDOWN = 'DUE_DATE_FILTER_DROPDOWN';
export const STATUS_FILTER_DROPDOWN = 'STATUS_FILTER_DROPDOWN';